import { createContext } from 'react'
import { ConfirmationProps } from '../components'

export type UpdateConfirmation = {
  setConfirmation: (confirmation: ConfirmationProps | null) => void
}

export const UpdateConfirmationContext = createContext<UpdateConfirmation>({
  setConfirmation: confirmation => {}
})
